// import React, { useState } from "react";
// import "./SalesExecutive.css"; // We'll create this CSS file
// import SalesDashboard from "./SalesExecutive/SalesDashboard.jsx";
// import SalesSourcing from "./SalesExecutive/SalesSourcing.jsx";
// import SalesEnquiries from "./SalesExecutive/SalesEnquiries.jsx";
// import SalseQuotation from "./SalesExecutive/SalseQuotation.jsx";
// import SalseClients from "./SalesExecutive/SalseClients.jsx";
// import SalesReports from "./SalesExecutive/SalesReports.jsx";
// import PurchaseOrders from "./SalesExecutive/PurchaseOrders.jsx";

// const DummySection = ({ title }) => {
//     return (
//         <div className="dummy-box">
//             <h2>{title}</h2>
//             <p>This is a dummy section for <strong>{title}</strong>.</p>
//             <span>Content will be added later 🚧</span>
//         </div>
//     );
// };

// const SalesExecutive = () => {
//     // Define tabs - You can customize these based on your needs
//     const tabs = [
//         { id: 1, name: "Dashboard", component: () => <SalesDashboard title="Dashboard" /> },
//         // { id: 9, name: "Sourcing", component: () => <SalesSourcing title="Sourcing" /> },
//         { id: 2, name: "Enquiries", component: () => <SalesSourcing title="Enquiries" /> },
//         { id: 3, name: "Quotations", component: () => <SalseQuotation title="Quotations" /> },
//         { id: 4, name: "Clients", component: () => <SalseClients title="Clients" /> },
//         // { id: 5, name: "Purchase", component: () => <SalesReports title="Reports" /> },
//         // Add more tabs as needed
//         // { id: 6, name: "Pipeline", component: () => <SalesPipeline title="Pipeline" /> },
//         // { id: 7, name: "Team", component: () => <SalesTeam title="Sales Team" /> },
//         { id: 8, name: "Purchase Orders", component: () => <PurchaseOrders title="Purchase Orders" /> },
//     ];

//     const [activeTab, setActiveTab] = useState(tabs[0].id);

//     const ActiveComponent = tabs.find((tab) => tab.id === activeTab)?.component;

//     return (
//         <div className="sales-executive-container">
//             {/* Tabs */}
//             <div className="se-tabs-wrapper">
//                 <div className="se-tabs-scroll">
//                     <div className="se-tabs-row">
//                         {tabs.map((tab) => (
//                             <button
//                                 key={tab.id}
//                                 className={`se-tab-btn ${activeTab === tab.id ? "se-tab-active" : ""
//                                     }`}
//                                 onClick={() => setActiveTab(tab.id)}
//                             >
//                                 {tab.name}
//                             </button>
//                         ))}
//                     </div>
//                 </div>
//             </div>

//             {/* Active Component */}
//             <div className="se-tab-content">
//                 {ActiveComponent && <ActiveComponent />}
//             </div>
//         </div>
//     );
// };

// export default SalesExecutive;



import React, { useState, useEffect } from "react";
import "./SalesExecutive.css";
import SalesDashboard from "./SalesExecutive/SalesDashboard.jsx";
import SalesSourcing from "./SalesExecutive/SalesSourcing.jsx";
import SalesEnquiries from "./SalesExecutive/SalesEnquiries.jsx";
import SalseQuotation from "./SalesExecutive/SalseQuotation.jsx";
import SalseClients from "./SalesExecutive/SalseClients.jsx";
import SalesReports from "./SalesExecutive/SalesReports.jsx";
import PurchaseOrders from "./SalesExecutive/PurchaseOrders.jsx";

const DummySection = ({ title }) => {
    return (
        <div className="dummy-box">
            <h2>{title}</h2>
            <p>This is a dummy section for <strong>{title}</strong>.</p>
            <span>Content will be added later 🚧</span>
        </div>
    );
};

const SalesExecutive = () => {
    // Define tabs - You can customize these based on your needs
    const tabs = [
        { id: 1, name: "Dashboard", component: () => <SalesDashboard title="Dashboard" /> },
        // { id: 9, name: "Sourcing", component: () => <SalesSourcing title="Sourcing" /> },
        { id: 2, name: "Enquiries", component: () => <SalesSourcing title="Enquiries" /> },
        { id: 3, name: "Quotations", component: () => <SalseQuotation title="Quotations" /> },
        // { id: 4, name: "Clients", component: () => <SalseClients title="Clients" /> },
        // { id: 5, name: "Purchase", component: () => <SalesReports title="Reports" /> },
        // Add more tabs as needed
        // { id: 6, name: "Pipeline", component: () => <SalesPipeline title="Pipeline" /> },
        // { id: 7, name: "Team", component: () => <SalesTeam title="Sales Team" /> },
        { id: 8, name: "Purchase Orders", component: () => <PurchaseOrders title="Purchase Orders" /> },
    ];

    const [activeTab, setActiveTab] = useState(tabs[0].id);

    // Listen for tab change events from child components (like Dashboard)
    useEffect(() => {
        const handleTabChange = (event) => {
            const tabId = event.detail?.tabId;
            
            if (tabId) {
                // Find tab by name (case insensitive)
                const tab = tabs.find(t => 
                    t.name.toLowerCase() === tabId.toLowerCase() || 
                    t.id === tabId
                );
                
                if (tab) {
                    setActiveTab(tab.id);
                } else {
                    console.warn("⚠️ Tab not found:", tabId);
                }
            }
        };

        window.addEventListener('changeTab', handleTabChange);
        return () => window.removeEventListener('changeTab', handleTabChange);
    }, [tabs]);

    const ActiveComponent = tabs.find((tab) => tab.id === activeTab)?.component;

    return (
        <div className="sales-executive-container">
            {/* Tabs */}
            <div className="se-tabs-wrapper">
                <div className="se-tabs-scroll">
                    <div className="se-tabs-row">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                className={`se-tab-btn ${activeTab === tab.id ? "se-tab-active" : ""
                                    }`}
                                onClick={() => setActiveTab(tab.id)}
                            >
                                {tab.name}
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            {/* Active Component */}
            <div className="se-tab-content">
                {ActiveComponent && <ActiveComponent />}
            </div>
        </div>
    );
};

export default SalesExecutive;